/**
 * CircularProgress
 *
 * SVG-based circular progress indicator. Shared between the diligence workbench
 * and the mission portal cycles table.
 */

type CircularProgressProps = {
  percentage: number;
  size?: number;
  strokeWidth?: number;
};

const CircularProgress = ({ percentage, size = 60, strokeWidth = 2 }: CircularProgressProps) => {
  const clamped = Math.min(Math.max(percentage, 0), 100);
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (clamped / 100) * circumference;
  const center = size / 2;

  return (
    <div className="circular-progress">
      <svg width={size} height={size} className="circular-progress__svg">
        <circle
          className="circular-progress__bg"
          cx={center}
          cy={center}
          r={radius}
          fill="none"
          stroke="#E5E7EB"
          strokeWidth={strokeWidth}
        />
        <circle
          className="circular-progress__bar"
          cx={center}
          cy={center}
          r={radius}
          fill="none"
          stroke="#C13D0C"
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          transform={`rotate(-90 ${center} ${center})`}
        />
      </svg>
      <span className="circular-progress__text">{Math.round(clamped)}%</span>
    </div>
  );
};

export default CircularProgress;
